import { useState, FormEvent } from 'react'
import styles from './LoginOperatore.module.css'

interface LoginOperatoreProps {
  onLoginSuccess: () => void
  login: (username: string, password: string) => Promise<boolean>
  error: string | null
  isLoading: boolean
}

export function LoginOperatore({ onLoginSuccess, login, error, isLoading }: LoginOperatoreProps) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [localError, setLocalError] = useState<string | null>(null)

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setLocalError(null)

    // Validazione
    if (!username.trim()) {
      setLocalError('Inserisci il tuo username')
      return
    }
    if (!password.trim()) {
      setLocalError('Inserisci la tua password')
      return
    }

    const success = await login(username.trim(), password)
    
    if (success) {
      onLoginSuccess()
    }
  }

  const displayError = localError || error

  const bgUrl = `${import.meta.env.BASE_URL}herabg.png`

  return (
    <div
      className={styles.container}
      style={{ backgroundImage: `url(${bgUrl})` }}
    >
      <div className={styles.card}>
        <div className={styles.header}>
          <img
            src="/assets/logo.webp"
            alt="Heracomm"
            className={styles.logo}
          />
        </div>

        <div className={styles.body}>
          <form className={styles.form} onSubmit={handleSubmit}>
            {displayError && (
              <div className={styles.error}>
                <i className="bi bi-exclamation-circle-fill" />
                <span>{displayError}</span>
              </div>
            )}

            <div className={styles.field}>
              <label className={styles.label} htmlFor="username">
                Username
              </label>
              <div className={styles.inputWrapper}>
                <i className={`bi bi-person ${styles.inputIcon}`} />
                <input
                  id="username"
                  type="text"
                  className={styles.input}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Inserisci username"
                  autoComplete="username"
                  disabled={isLoading}
                  autoFocus
                />
              </div>
            </div>

            <div className={styles.field}>
              <label className={styles.label} htmlFor="password">
                Password
              </label>
              <div className={styles.inputWrapper}>
                <i className={`bi bi-lock ${styles.inputIcon}`} />
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  className={styles.input}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Inserisci password"
                  autoComplete="current-password"
                  disabled={isLoading}
                />
                <button
                  type="button"
                  className={styles.passwordToggle}
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                  aria-label={showPassword ? 'Nascondi password' : 'Mostra password'}
                >
                  <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} />
                </button>
              </div>
            </div>

            <button
              type="submit"
              className={styles.submitButton}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className={styles.spinner} />
                  Accesso in corso...
                </>
              ) : (
                <>
                  <i className="bi bi-box-arrow-in-right" />
                  Accedi
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
